// extracted by mini-css-extract-plugin
export default {"header":"PoleEducation2_header__NkwcK","imageContainer":"PoleEducation2_imageContainer__-xZ0w","headerImage":"PoleEducation2_headerImage__aaFTM"};